import { SimulatorType } from "@/types/api/SimulatorType"

export const audioOnlyMetricEnabled = (simulatorType: SimulatorType) => {
  const isVoice =
    simulatorType === SimulatorType.VOICE ||
    simulatorType === SimulatorType.OUTBOUND_VOICE ||
    simulatorType === SimulatorType.WEBSOCKET ||
    simulatorType === SimulatorType.LIVEKIT ||
    simulatorType === SimulatorType.OPENAI_REALTIME ||
    simulatorType === SimulatorType.GEMINI_REALTIME ||
    simulatorType === SimulatorType.GROK_REALTIME ||
    simulatorType === SimulatorType.DEEPGRAM_REALTIME ||
    simulatorType.includes("VOICE") //to cover custom ones
  return {
    result: isVoice,
    // Kept to a short phrase: the picker prints it beside the metric's name in
    // a narrow column, where a full sentence can only truncate.
    error_message: isVoice ? "" : "Requires a voice simulator",
  }
}
